export default {
      id: "ic_highlight_green-usage",
      viewBox: "0 0 21 32",
      url: "/" + "images/icons.3.109.2.svg#ic_highlight_green-usage",
      toString: function () {
        return this.url;
      }
    }